interface Config {
  firebase: {
    apiKey: string
    authDomain: string
    projectId: string
    storageBucket: string
    messagingSenderId: string
    appId: string
    measurementId: string
  }
}

const config: Config = {
  firebase: {
    apiKey: process.env.GATSBY_FIREBASE_APIKEY ?? "",
    authDomain: process.env.GATSBY_FIREBASE_AUTH_DOMAIN ?? "",
    projectId: process.env.GATSBY_FIREBASE_PROJECT_ID ?? "",
    storageBucket: process.env.GATSBY_FIREBASE_STORAGE_BUCKET ?? "",
    messagingSenderId: process.env.GATSBY_FIREBASE_MESSAGING_SENDER_ID ?? "",
    appId: process.env.GATSBY_FIREBASE_APP_ID ?? "",
    measurementId: process.env.GATSBY_FIREBASE_MEASUREMENT_ID ?? "",
  }
}

// console.log('config', config)

export default config

